import * as React from "react";
export default class MadeInAlberta extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return this.props.madeInAlberta ?
            React.createElement("div", { className: "made-in-alberta" },
                React.createElement("img", { src: "/img/alberta-made.png" })) : null;
    }
}
//# sourceMappingURL=made-in-alberta.js.map